// extracted by mini-css-extract-plugin
module.exports = {"toggle":"Toggle_toggle__2taOW"};